












































































































































































































































































































































































































































import PlaylistContentCard from "./PlaylistContentCard.vue";
import GroupPlaylists from "./Devices/GroupPlaylists.vue";
import GroupInformation from "./Devices/GroupInformation.vue";
import GroupSettings from "./Devices/GroupSettings.vue";
import AssignPlaylistModal from "./Devices/AssignPlaylistModal.vue";
import DeviceSettings from "./Devices/DeviceSettings.vue";
import { mapGetters, mapActions } from "vuex";
import { Container } from "vue-smooth-dnd";
import sharedMethods from "../sharedMethods";
import { applyDrag } from "../utils/helpers";
import { copyToClipboard } from "quasar";
import Device from "../classes/Device";

export default {
  components: { PlaylistContentCard, Container, GroupPlaylists, GroupInformation, GroupSettings, AssignPlaylistModal, DeviceSettings },
  props: ["activeDevice", "tab", "activeGroup"],
  computed: {
    ...mapGetters(["getDeviceAssignedPlaylistsByID", "getMediaFilesForPlaylist", "allDeviceGroupSelectOptions", "allUserPlaylists", "getDeviceAssignedPlaylistByIDs", "allDeviceGroups"]),
    editableActiveDevice() {
      if (this.activeDevice) {
        // copy device to avoid props mutation
        return Device.fromObject(this.activeDevice.toObject());
      } else {
        return null;
      }
    },
  },

  data() {
    return {
      userIsAdmin: false,
      showPlaylistModal: false,
      showVersionsModalMp: false,
      showVersionsModalSm: false,
      //editableActiveDevice: this.activeDevice ? Device.fromObject(this.activeDevice.toObject()) : null,
      versions: {},
      versionmp: "",
      versionsm: "",
      vmodelAssignedPlaylistsToCurrentDevice: [],
      selectedDeviceGroup: {
        label: this.activeGroup ? this.activeGroup.GNAME : "",
        value: this.activeGroup,
      },
      deviceOrientationOptions: [
        { label: "Use Group Orientation", value: "useGroupOrientation" },
        { label: "Landscape", value: "LANDSCAPE" },
        { label: "Portrait", value: "PORTRAIT" },
        { label: "reversed Portrait", value: "REVERSED_PORTRAIT" },
        { label: "reversed Landscape", value: "REVERSED_LANDSCAPE" },
      ],
      deviceConfigOptions: [
        { label: "yes", value: 1 },
        { label: "no", value: 0 },
      ],
      deviceConnectPathOptions: [
        {
          label: "CMS V2 A",
          value: "https://api.mirrads.de/api/devices/v2/device-api",
        },
        {
          label: "CMS V1 A",
          value: "https://api.mirrads.de/api/deviceAPI",
        },
        {
          label: "CMS V2 B",
          value: "https://api-b.mirrads.de/api/devices/v2/device-api",
        },
        {
          label: "DEV V2",
          value: "https://api-dev.mirrads.de/api/devices/v2/device-api",
        },
        {
          label: "DEV V1",
          value: "https://api-dev.mirrads.de/api/deviceAPI",
        },
        {
          label: "Q V2",
          value: "https://api-q.mirrads.de/api/devices/v2/deviceAPI",
        },
        {
          label: "Q V1",
          value: "https://api-q.mirrads.de/api/deviceAPI",
        },
      ],
      availableMasters: [{ label: "none", value: null }],
      // index of the last add event from on drop
      lastAddedIndex: -1,
      lastPlaylistToAddIndex: -1,

      // last removed item from on drop
      lastRemovedItem: null,
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
    };
  },
  watch: {
    activeDevice() {
      this.prepareInitState();
    },
  },
  mounted() {
    if ("" + this.$route.query.adm != "undefined") {
      this.userIsAdmin = true;
    } else {
      this.userIsAdmin = false;
    }

    this.prepareInitState();
  },
  methods: {
    ...mapActions([
      "changeDeviceGroupAssignment",
      "updatePlaylistContentV2",
      "changeDeviceConfigByID",
      "removePlaylistFromDevice",
      "fetchAllUserPlaylists",
      "changeDeviceConnectpath",
      "getDeviceVersions",
      "updateTargetVersions",
    ]),
    getNetworkString(deviceNetworkData: string) {
      switch (deviceNetworkData) {
        case "wifi1":
          return "too weak";
        case "wifi2":
          return "bad";
        case "wifi3":
          return "medium - might cause problems";
        case "wifi4":
          return "good";
        case "wifi5":
          return "excellent";
        default:
          return "no data available";
      }
    },
    prepareInitState() {
      if (this.editableActiveDevice) {
        this.vmodelAssignedPlaylistsToCurrentDevice = this.getDeviceAssignedPlaylistByIDs(this.editableActiveDevice.DID);
        this.availableMasters = [];

        this.availableMasters.push({
          label: "none",
          value: null,
        });

        // add possible masters (all devices except current one)
        this.allDeviceGroups.forEach((group) => {
          group.devices.forEach((device) => {
            if (device.NAME && device.DID != this.editableActiveDevice.DID) {
              this.availableMasters.push({
                label: device.NAME,
                value: device.IDENTIFIER,
              });
            }
          });
        });

        this.selectedDeviceGroup = {
          label: this.activeGroup.GNAME,
          value: this.activeGroup,
        };

        this.versionmp = this.activeDevice.APPVERSION;
        this.versionsm = this.activeDevice.APPVERSIONSM;
        this.versions = {
          mediaPlayer: [{ version: "" }],
          serviceManager: [{ version: "" }],
        };
      }
    },
    updateDeviceSettings() {
      this.$emit("deviceUpdated", this.editableActiveDevice);
      // update the device config
      this.changeDeviceConfigByID(this.editableActiveDevice.toDeviceSettingsObject()).then((response) => {
        if (response.data.status === 200) {
          sharedMethods.successNotify("Updated device settings successfully");
        } else {
          console.error("UpdateDeviceSettings Error: " + response);
          sharedMethods.errorNotify("Error updating device settings");
        }
      });
    },
    changeConnectpath() {
      this.$emit("deviceUpdated", this.editableActiveDevice);

      this.changeDeviceConnectpath(this.editableActiveDevice).then((response) => {
        if (response.status === 200) {
          sharedMethods.successNotify("Updated all device settings successfully");
        } else {
          console.error("UpdateDeviceSettings Error: " + response.msg);
          sharedMethods.errorNotify("Error updating device settings: " + response.msg);
        }
      });
    },
    copyToClipboard(text: string) {
      copyToClipboard(text);
    },

    removePLfromDevice(PLID) {
      this.removePlaylistFromDevice({
        device: this.editableActiveDevice.DID,
        playlist: PLID,
      }).then((response) => {
        if (response.status === 200) {
          sharedMethods.successNotify("Playlist removed");
        } else {
          sharedMethods.errorNotify("Playlist could not be removed");
          console.error(response);
        }

        this.fetchAllUserPlaylists().then(() => {
          this.vmodelAssignedPlaylistsToCurrentDevice = this.getDeviceAssignedPlaylistByIDs(this.editableActiveDevice.DID);
        });
      });
    },
    updateDeviceGroup() {
      const requestBody = {
        deviceId: this.editableActiveDevice.DID,
        groupId: this.selectedDeviceGroup.value.GID,
      };

      this.changeDeviceGroupAssignment(requestBody).then((response) => {
        if (response.status === 200) {
          this.$emit("activeGroupChanged", this.selectedDeviceGroup.value);
          sharedMethods.successNotify(response.data);
        } else {
          sharedMethods.errorNotify(response.data);
        }
      });
    },
    onDrop(collection, dropResult, playlist) {
      const { removedIndex, addedIndex } = dropResult;
      const fromPlaylist = !!dropResult.payload.fromPlaylist;

      let playlistContent = this.getMediaFilesForPlaylist(playlist);

      // check if we dropped a content from another playlist
      // this means that this function will be called many times
      // at least once for the add and once for the remove of the content
      if (fromPlaylist) {
        dropResult.payload = playlistContent[dropResult.payload.index];

        if (addedIndex !== null && removedIndex === null) {
          // we added sth

          if (!this.lastRemovedItem) {
            // save drop position
            this.lastAddedIndex = addedIndex;
            this.lastPlaylistToAddIndex = collection;

            // break function here (it will be called another time)
            return;
          } else {
            // we removed sth before the add action

            // add last removed item as current payload
            dropResult.payload = this.lastRemovedItem;
            this.lastRemovedItem = null;
          }
        } else if (addedIndex === null && removedIndex !== null) {
          // we removed sth

          if (this.lastPlaylistToAddIndex >= 0) {
            // we added sth before

            let allPlaylists = this.getDeviceAssignedPlaylistsByID(this.editableActiveDevice.DID);

            // avoid a vuex store mutation with json
            const contentIds = JSON.parse(JSON.stringify(allPlaylists[this.lastPlaylistToAddIndex].contentIds));

            // add current content to given position
            contentIds.splice(this.lastAddedIndex, 0, dropResult.payload.id);

            this.updatePlaylistContentV2({
              content: contentIds,
              playlistId: allPlaylists[this.lastPlaylistToAddIndex].ID,
            });

            this.lastPlaylistToAddIndex = -1;
          } else {
            // save dropped item
            this.lastRemovedItem = dropResult.payload;
          }
        }
      }

      // add new media into current media files
      var tmp = applyDrag(playlistContent, dropResult);

      // get only the content ids of the new playlist
      let contentIds = [];
      tmp.forEach((content) => {
        if (content) {
          if (content.contentGroup) {
            contentIds.push(content.contentGroupId);
          } else {
            contentIds.push(content.id);
          }
        }
      });

      if (fromPlaylist || addedIndex != null) {
        // update playlist in db
        this.updatePlaylistContentV2({
          content: contentIds,
          playlistId: playlist.ID,
        });
      }
    },
    getChildPayload(index) {
      return { index: index, fromPlaylist: true };
    },
    async openVersionsModalMp() {
      this.showVersionsModalMp = !this.showVersionsModalMp;
      this.versions = await this.getDeviceVersions();
    },
    async openVersionsModalSm() {
      this.showVersionsModalSm = !this.showVersionsModalSm;
      this.versions = await this.getDeviceVersions();
    },
    async updateVersion() {
      if (!this.versionmp) {
        this.versionmp = "";
      }
      if (!this.versionsm) {
        this.versionsm = "";
      }
      await this.updateTargetVersions({ deviceId: this.editableActiveDevice.DID, versionmp: this.versionmp, versionsm: this.versionsm });
    },
  },
};
